/**
 * @author      warinya.rojanasuwan@zumper.com (Warinya Rojanasuwan)
 * @copyright   Copyright (c) 2022, Zumper
 */

export const traverseParentsForSelectors = (
  node: HTMLElement | null,
  selectorString: string
): string => {
  if (selectorString.length > 100 || !node) {
    return selectorString
  }
  if (!node.id && !node.className) {
    return traverseParentsForSelectors(node.parentElement, selectorString)
  }
  let nextSelectorString = node.tagName?.toLowerCase() ?? ''

  if (node.id) {
    nextSelectorString += `#${node.id}`
  }
  if (node.className) {
    nextSelectorString += `.${node.className}`
  }

  return traverseParentsForSelectors(
    node.parentElement,
    `${nextSelectorString} ${selectorString}`
  )
}
